export default __webpack_public_path__ + "static/media/icon-help.76a3952d.svg";